module.exports = __webpack_public_path__ + "img/our_advantage1.8d721f6d.png";